import React, {useState, useEffect, useRef} from "react";
import {
    MDBBtn,
    MDBCol,
    MDBContainer, MDBInput,
    MDBRow,
} from "mdbreact"
import classes from './CommunityReport.module.css'
import firebase from "../../../Config/firebase";
import {Link, withRouter} from "react-router-dom";
import {connect} from "react-redux";
import {getDownloadLink, isAuth} from "../../../Utils/firebaseUtils";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowLeft, faCircle, faPen, faPlus, faSave, faScroll, faVoteYea} from "@fortawesome/free-solid-svg-icons";
import ReportSection from "./ReportSection/ReportSection";
import {v4 as uuidv4} from "uuid";
import SocialComment from "./SocialComment/SocialComment";
import NewSocialComment from "./SocialComment/NewSocialComment";
import AnchorLink from "react-anchor-link-smooth-scroll";
import Jdenticon from "react-jdenticon";
import Compressor from "compressorjs";

const db = firebase.firestore()
const CommunityReport = (props) => {
    const itemsRef = useRef([]);
    const [isLoaded, setIsLoaded] = useState(false)
    const [noItem, setNoItem] = useState(false)
    const [isAdmin, setIsAdmin] = useState(false)
    const [isEditMode, setIsEditMode] = useState(false)
    const [section, setSection] = useState([])
    const [isSaved, setIsSaved] = useState(false)

    const [community, setCommunity] = useState({})
    const [isLoadedCommunity, setIsLoadedCommunity] = useState(false)

    const [sComment, setSComment] = useState([])
    const [isLoadedComment, setIsLoadedComment] = useState(false)
    const [noSComment, setNoSComment] = useState(false)
    const [isAddNewComment, setIsAddNewComment] = useState(false)

    const [removedItemIDs, setRemovedItemIDs] = useState([])

    const [isSubscribed, setIsSubscribed] = useState(false)
    const [isUploading, setIsUploading] = useState(false)

    useEffect(() => {
        setIsLoadedComment(false)
        setIsLoaded(false)
        setSection([])
        setSComment([])
        getCommunityFromFirebase(props.match.params.cid)
        getReportSection(props.match.params.cid)
        getSocialMediaComment(props.match.params.cid)
    }, [props.match.params.cid])

    useEffect(() => {
        if (isAuth(props.auth)) {
            firebase.auth().currentUser.getIdTokenResult()
                .then((idTokenResult) => {
                    if (idTokenResult.claims.type === "administrator") {
                        setIsAdmin(true)
                    }
                })

            getSubscribeState(props.match.params.cid)
        }
    }, [props.auth])

    const subscribe = (id) => {
        db.collection('Member')
            .doc(props.auth.uid)
            .update({
                subscribedList: firebase.firestore.FieldValue.arrayUnion(id)
            })
            .then(res => {
                setIsSubscribed(true)
            })
            .catch(err => console.log(err))
    }

    const unsubscribe = (id) => {
        db.collection('Member')
            .doc(props.auth.uid)
            .update({
                subscribedList: firebase.firestore.FieldValue.arrayRemove(id)
            })
            .then(res => {
                setIsSubscribed(false)
            })
            .catch(err => console.log(err))
    }

    const getSubscribeState = (id) => {
        db.collection('Member')
            .doc(props.auth.uid)
            .get()
            .then(doc => {
                if (doc.exists) {
                    if (Array.isArray(doc.data().subscribedList))
                        setIsSubscribed(doc.data().subscribedList.includes(id))
                }
            })
    }

    const getCommunityFromFirebase = (cid) => {
        setIsLoadedCommunity(false)
        db.collection('Community').doc(cid)
            .get()
            .then(doc => {
                if (doc.exists) {
                    setCommunity({
                        id: doc.id,
                        ...doc.data()
                    })
                    setIsLoadedCommunity(true)
                }
            })
            .catch(err => console.log(err))
    }

    const getReportSection = (cid) => {
        setNoItem(false)
        db.collection('Community')
            .doc(cid)
            .collection('Report')
            .orderBy('order', "asc")
            .get()
            .then(docs => {
                if (!docs.empty) {
                    let allSection = []
                    docs.forEach(doc => {
                        allSection.push({
                            id: doc.id,
                            ...doc.data()
                        })
                    })
                    setSection(allSection)
                    setIsLoaded(true)
                } else {
                    setNoItem(true)
                    setIsLoaded(true)
                }
            })
            .catch(err => console.log(err))
    }

    const getSocialMediaComment = (cid) => {
        setNoItem(false)
        db.collection('Community')
            .doc(cid)
            .collection('WebComment')
            .get()
            .then(docs => {
                if (!docs.empty) {
                    let allComment = []
                    docs.forEach(doc => {
                        allComment.push({
                            id: doc.id,
                            ...doc.data()
                        })
                    })
                    setSComment(allComment)
                    setIsLoadedComment(true)
                } else {
                    setNoSComment(true)
                    setIsLoadedComment(true)
                }
            })
            .catch(err => console.log(err))
    }

    const returnNewSocialMediaComment = (newSComment) => {
        let newAllSComment = sComment.concat(newSComment)
        setSComment(newAllSComment)
        setIsLoadedComment(true)
    }

    const addSection = () => {
        let newSection = section.concat({
            ListItem: [],
            topicName: 'NEW SECTION',
            order: section.length,
            id: uuidv4(),
            isHeading: false,
            isNew: true,
        })
        setSection(newSection)
        setIsLoaded(true)
    }

    const saveCommunityReport = () => {
        let allData = []
        if (Array.isArray(itemsRef.current)) {
            itemsRef.current.forEach(ref => {
                if (ref !== null) {
                    allData.push(ref.returnData())
                }
            })
        }

        if (Array.isArray(removedItemIDs)) {
            let allPromise = []
            removedItemIDs.map(e => {
                allData.map(item => {
                    allPromise.push(new Promise((resolve, reject) => {
                        db.collection('Community')
                            .doc(props.match.params.cid)
                            .collection('Report')
                            .doc(e)
                            .delete()
                            .then(res => {
                                resolve()
                            })
                    }))
                })
            })
        }

        if (Array.isArray(allData)) {
            let allPromise = []
            allData.map(item => {
                allPromise.push(new Promise((resolve, reject) => {
                    let newIndex = section.findIndex(e => e.id === item.id)
                    let newItem = {
                        ListItem: item.ListItem,
                        topicName: item.topicName,
                        order: newIndex,
                        isHeading: item.isHeading ? item.isHeading : false
                    }
                    if (item.isNew) {
                        //new Section
                        db.collection('Community')
                            .doc(props.match.params.cid)
                            .collection('Report')
                            .doc(item.id)
                            .set(newItem)
                            .then(res => {
                                resolve(true)
                            })
                    } else {
                        db.collection('Community')
                            .doc(props.match.params.cid)
                            .collection('Report')
                            .doc(item.id)
                            .update(newItem)
                            .then(res => {
                                resolve(true)
                            })
                    }

                }))
            })

            Promise.all(allPromise)
                .then(res => {
                    db.collection('Community')
                        .doc(props.match.params.cid)
                        .update({
                            featureLabel: typeof community.featureLabel !== 'undefined' ? community.featureLabel : '',
                            avatar: typeof community.avatar !== 'undefined' ? community.avatar : ''
                        })
                        .then(res => {
                            setIsSaved(true)
                            setIsEditMode(false)
                            setTimeout(() => {
                                setIsSaved(false)
                            }, 2000)
                        })

                })
        }
    }

    const deleteSection = (objectID) => {
        let removeObject = section.find(e => e.id === objectID)
        let newSection = section.filter(e => e.id !== objectID)
        setSection(newSection)

        let newRemovedItemIDs = removedItemIDs
        newRemovedItemIDs.push(removeObject.id)
        setRemovedItemIDs(newRemovedItemIDs)

    }

    const removeComment = (objectID) => {
        db.collection('Community')
            .doc(props.match.params.cid)
            .collection('WebComment')
            .doc(objectID)
            .delete()
            .then(res => {
                let newComment = sComment
                newComment = newComment.filter(e => e.id !== objectID)
                setSComment(newComment)
            })
    }

    const sortUp = (objectID) => {
        let newSection = [...section]
        let object = section.find((el) => el.id === objectID)
        const index = section.findIndex(e => e.id === objectID)
        if (index === -1 || typeof object === 'undefined') {
            return 0
        } else {
            newSection.splice(index, 1);
            newSection.splice(index - 1, 0, object);
            setSection(newSection)
        }
    }

    const sortDown = (objectID) => {
        let newSection = [...section]
        let object = section.find((el) => el.id === objectID)
        const index = section.findIndex(e => e.id === objectID)
        if (index === -1 || typeof object === 'undefined') {
            return 0
        } else if (index !== 1) {
            newSection.splice(index, 1);
            newSection.splice(index + 1, 0, object);
            setSection(newSection)
        } else {
            return 0
        }

    }

    const updateSectionData = (objectID, sectionData) => {
        let newSection = [...section]
        let object = section.find((el) => el.id === objectID)
        const index = section.findIndex(e => e.id === objectID)
        newSection[index] = sectionData
        setSection(newSection)
    }

    const updateSectionDataValue = (objectID, fieldName, value) => {
        let newSection = [...section]
        let object = section.find((el) => el.id === objectID)
        let newSectionData = {
            ...object,
            [fieldName]: value
        }

        const index = section.findIndex(e => e.id === objectID)
        newSection[index] = newSectionData
        setSection(newSection)
    }



    const fileCompress = (file) => {
        return new Promise(async (resolve, reject) => {
            new Compressor(file, {
                file: 'blob',
                quality: 0.60,
                maxWidth: 150,
                maxHeight: 150,
                width: 150,
                height: 150,
                success(result) {
                    return resolve({
                        success: true,
                        file: result
                    })
                },
                error(err) {
                    return resolve({
                        success: false,
                        message: err.message
                    })
                },
            })
        })
    }

    const uploadFile = async (e) => {
        return new Promise(async (resolve, reject) => {
            let file = e.target.files[0]
            if (file !== null) {
                const compressState = await fileCompress(file)
                if (compressState.success) {
                    const uuid = uuidv4()
                    let imageRef = firebase.storage().ref('Community/' + props.match.params.cid + '/' + uuid)
                    imageRef
                        .put(compressState.file)
                        .then(async (snapshot) => {
                            const getState = await getDownloadLink('Community/' + props.match.params.cid + '/' + uuid)
                            if (getState.success) {
                                resolve({
                                    success: true,
                                    downloadLink: getState.downloadLink
                                })
                            }

                        })
                        .catch(err => {
                            console.log(err)
                            resolve({
                                success: false,
                                message: err.message
                            })
                        })
                }
            }
        })
    }

    return (
        <MDBContainer>
            <MDBRow>
                <MDBCol xs='4' sm='4' md='4' lg='4' xl='2'>
                    <div className={classes.ImageContainer}>
                        {
                            isLoadedCommunity && !isEditMode ?
                                typeof community.avatar !== 'undefined' && community.avatar !== '' ?
                                    <img src={community.avatar} alt={community.titleCHI}
                                         className={classes.Avatar}/>
                                    :
                                    <Jdenticon size="100" value={community.id}/>
                                : ''
                        }

                        {
                            isEditMode &&
                            <input type={'file'} className={classes.ImageUploader}
                                   disabled={isUploading}
                                   id={'uploader'}
                                   accept="*"
                                   onChange={async (e) => {
                                       setIsUploading(true)
                                       const uploadState = await uploadFile(e)
                                       if (uploadState.success) {
                                           let newCommunity = community
                                           newCommunity.avatar = uploadState.downloadLink
                                           setCommunity(newCommunity)
                                           setIsUploading(false)
                                           setIsEditMode(false)
                                       }
                                   }}
                            />
                        }
                    </div>
                </MDBCol>
                <MDBCol xs='4' sm='4' md='4' lg='4' xl='8'>
                    <MDBRow>
                        <MDBCol>
                            <h2>
                                {isLoadedCommunity ? community.titleCHI : ''}
                            </h2>
                        </MDBCol>
                    </MDBRow>
                </MDBCol>
                <MDBCol xs='4' sm='4' md='4' lg='4' xl='2'>
                    <div className={classes.SubscribeBtnContainer}>
                        {
                            isAuth(props.auth) ?
                                <MDBBtn color={isSubscribed ? 'danger' : "link"}
                                        className={!isSubscribed && classes.SubscribeBtn}
                                        onClick={() => {
                                            if (isSubscribed) {
                                                unsubscribe(community.id)
                                            } else {
                                                subscribe(community.id)
                                            }
                                        }}
                                >
                                    {isSubscribed ? "取消訂閱" : "訂閱"}
                                </MDBBtn>
                                :
                                <MDBBtn color="info">
                                    請先登入
                                </MDBBtn>
                        }

                    </div>
                </MDBCol>
            </MDBRow>
            {
                isAdmin &&
                <>
                    <button className={classes.EditBtn} onClick={() => {
                        if (isEditMode) {
                            setIsAddNewComment(false)
                        }
                        setIsEditMode(!isEditMode)


                    }}>
                        Edit <FontAwesomeIcon icon={faPen}/>
                    </button>
                    <button disabled={isSaved} className={isSaved ? classes.SaveBtnSuccess : classes.SaveBtn}
                            onClick={() => saveCommunityReport()}>
                        Save <FontAwesomeIcon icon={faSave}/>
                    </button>
                </>

            }
            <MDBRow>
                <div className={classes.Title}>
                    🤔 Tmingler見解:
                    <h1>
                        <div className={classes.FeatureLabel}>
                            {
                                isLoadedCommunity && isEditMode ?
                                    <MDBInput value={community.featureLabel}
                                              className={classes.EditFeatureLabel}
                                              onChange={(e) => setCommunity({
                                                  ...community,
                                                  featureLabel: e.target.value
                                              })}>
                                    </MDBInput>
                                    :
                                    <div>
                                        {community.hasOwnProperty('featureLabel') ? community.featureLabel : ''}
                                    </div>
                            }
                        </div>
                        <span style={{fontSize : "30px"}}>
                            {isLoadedCommunity ? community.titleCHI !== '' ? community.titleCHI : community.title : '學校'}
                        </span>
                    </h1>

                </div>
                {/*<div className={classes.Description}>*/}
                {/*    {isLoadedCommunity ? community.description : 'description'}*/}
                {/*</div>*/}
            </MDBRow>

            <MDBRow>

                <div className={classes.FeatureTitle}>

                    {
                        isEditMode &&
                        <AnchorLink offset='120' href={"#social-comment"}>
                            <button disabled={isSaved} className={classes.AddSectionBtn}
                                    onClick={() => addSection()}>
                                Add <FontAwesomeIcon icon={faPlus}/>
                            </button>
                        </AnchorLink>
                    }
                </div>


                <div className={classes.ReportContainer}>
                    {
                        isLoaded &&
                        section.map((e, index) => {
                            return (
                                <ReportSection
                                    ref={el => itemsRef.current[index] = el}
                                    key={'se' + index}
                                    updateSectionData={updateSectionData}
                                    updateSectionDataValue={updateSectionDataValue}
                                    data={e}
                                    index={index}
                                    sectionLength={section.length}
                                    isEditMode={isEditMode}
                                    cid={props.match.params.cid}
                                    auth={props.auth}
                                    isAdmin={isAdmin}
                                    deleteSection={deleteSection}
                                    sortUp={sortUp}
                                    sortDown={sortDown}
                                />
                            )
                        })
                    }
                </div>
                <div className={classes.BottomAddBtn}>
                    {
                        isEditMode &&
                        <AnchorLink offset='120' href={"#social-comment"}>
                            <button disabled={isSaved} className={classes.AddSectionBtn}
                                    onClick={() => addSection()}>
                                Add <FontAwesomeIcon icon={faPlus}/>
                            </button>
                        </AnchorLink>
                    }
                </div>
            </MDBRow>

            <MDBRow id={"social-comment"} className={classes.SocialComment}>
                <div className={classes.FeatureTitle}>
                    <h3 className={classes.Subtitle}>
                        互聯網上的討論
                    </h3>
                    {
                        isEditMode &&
                        <button disabled={isSaved} className={classes.AddSectionBtn}
                                onClick={() => setIsAddNewComment(true)}>
                            Add <FontAwesomeIcon icon={faPlus}/>
                        </button>
                    }
                </div>

                {
                    isAddNewComment &&
                    <NewSocialComment
                        returnNewSocialMediaComment={returnNewSocialMediaComment}
                        auth={props.auth}
                        cid={props.match.params.cid}
                        isAdmin={isAdmin}
                    />
                }

                {
                    isLoadedComment &&
                    sComment.map((e, index) => {
                        return (
                            <SocialComment
                                key={"soco" + index.toString()}
                                data={e}
                                isEditMode={isEditMode}
                                removeComment={removeComment}
                                cid={props.match.params.cid}
                                auth={props.auth}
                                isAdmin={isAdmin}
                            />
                        )
                    })
                }
            </MDBRow>
        </MDBContainer>
    )
}

const enhance = connect(
    ({firebase: {auth, profile}}) => ({
        auth,
        profile
    })
)

export default enhance(withRouter(CommunityReport))